import ProjectListWrapper from 'components/commercetools-ui/organisms/project-builder/list';
import React, { useEffect, useState } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mediumDesktop } from 'helpers/utils/screensizes';
import { useRouter, useParams } from 'next/navigation';
import { useAccount, useProjectBuilder } from 'frontastic';
import RegisterPopup from 'components/commercetools-ui/organisms/authentication/register/register-popup';
import Spinner from 'components/commercetools-ui/organisms/spinner';
import NavigationMenu from 'components/commercetools-ui/organisms/NavigationMenu';

interface Project {
  projectLocation: string;
  lastModifiedAt: string | undefined;
  createdAt: string | undefined;
  projectType: string | undefined;
  projectName: string | undefined;
  projectId: string;
  name: string;
  status: 'open' | 'closed';
  username: string;
}
interface ProjectList {
  count: number;
  limit: number;
  offset: number;
  total: number;
  results: Project[];
}

const ProjectListMemo = React.memo(ProjectListWrapper);

export default function ProjectDashboard() {
  const [isMediumDesktop] = useMediaQuery(mediumDesktop);
  const { loggedIn, account } = useAccount();
  const router = useRouter();
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState<any>(true);
  const [createNav, setCreateNav] = useState<any>(false);

  const [projects, setProjects] = useState<ProjectList>({
    count: 0,
    limit: 0,
    offset: 0,
    total: 0,
    results: [],
  });
  const { getMyProjectsDashboard, deleteProject, updateProjectStatus } = useProjectBuilder();
  const { locale } = useParams();

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const payload = { limit: 0, offset: 0 };
      const responseBody: any = await getMyProjectsDashboard(payload);
      setProjects(responseBody.data);
    } catch (err) {
      console.error('Error fetching projects:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (projects?.total === 0) {
      fetchProjects();
    }
  }, []);

  const handleClick = () => {
    if (!loggedIn) {
      setOpen(true);
      setShowRegisterPopup(true);
      setCreateNav(true);
      return;
    }
    const redirectPath = account?.firstName ? '/project-builder/create' : `${locale}/company-registration/`;

    router.push(redirectPath);
  };
  const handleCancel = () => {
    setOpen(false);
    setShowRegisterPopup(false);
  };

  useEffect(() => {
    if (loggedIn && createNav && account?.firstName) {
      router.push('/project-builder/create');
    }
    if (!account?.firstName) {
      router.push('/company-registration');
    }
  }, [loggedIn, createNav]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div
      id="list-container"
      className={`sidemenu-container p-[32px] md:p-[60px] ${isMediumDesktop ? 'flex flex-row gap-[128px]' : ''}`}
    >
      {isMediumDesktop && (
        <div className="w-[20%]">
          <div className={`min-w-[300px] rounded-md bg-[#F7F7F7] text-black`}>
            <NavigationMenu loggedIn={loggedIn} />
          </div>
        </div>
      )}
      <div className={`${isMediumDesktop ? 'lg:w-[70%]' : ''}`}>
        {!projects?.total ? (
          <>
            <span>
              <h1 className="fontSize32-sm font-medium">Welcome to My Specifications</h1>
            </span>
            <div className="fontSize18-sm mt-30 font-medium">
              {!loggedIn ? 'Login to create your first project.' : 'Let’s start by creating your first project'}
            </div>
            <Button
              className={`!mb-32 !mt-45 w-full !cursor-pointer rounded-none !bg-gray-700 !px-25 !py-13 text-center text-14 disabled:cursor-auto disabled:!bg-gray-400 md:!mb-[80px] md:!mt-[40px] md:w-fit`}
              type="button"
              onClick={handleClick}
            >
              {!loggedIn ? 'Sign in / Sign up' : 'Create a project'}
            </Button>
            {showRegisterPopup && (
              <RegisterPopup
                showPopup={open && !loggedIn}
                setShowPopup={() => {}}
                defaultLoginModal={true}
                handleModalCancel={handleCancel}
              />
            )}
          </>
        ) : (
          <>
            <ProjectListMemo totalRecords={projects?.total}  getMyProjectsDashboard={getMyProjectsDashboard}
             deleteProject={deleteProject} updateProjectStatus={updateProjectStatus}/>
          </>
        )}
      </div>
    </div>
  );
}
